import { TabPanel as HeadlessUiTabTabPanel } from '@headlessui/react';

import Props from '@/components/@base/tab/panel/type';

export default function Panel({ children, ...props }: Props) {
  return <HeadlessUiTabTabPanel {...props}>{children}</HeadlessUiTabTabPanel>;
}
